import { render, staticRenderFns } from "./customer-product-history-list.vue?vue&type=template&id=76d03674"
import script from "./customer-product-history-list.vue?vue&type=script&lang=js"
export * from "./customer-product-history-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports